import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { UserX, AlertTriangle, Building2 } from "lucide-react";

export default function SemConsultorAlert({ semConsultor, openPanel, focarSemConsultor }) {
  return (
    <div
      className="rounded-xl border-2 border-red-500/50 bg-red-500/10 p-4 flex items-start gap-3"
      data-testid="alert-sem-consultor"
    >
      <div className="w-10 h-10 rounded-lg grid place-items-center bg-red-500/20 border border-red-500/40 shrink-0">
        <UserX className="w-5 h-5 text-red-500" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <AlertTriangle className="w-4 h-4 text-red-500" />
          <h4 className="font-heading font-bold text-red-500">
            {semConsultor.length === 1
              ? "1 condomínio sem consultor atribuído"
              : `${semConsultor.length} condomínios sem consultor atribuído`}
          </h4>
          <Badge variant="outline" className="border-red-500/40 text-red-500 text-[10px]">Ação recomendada</Badge>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Prédios atendidos sem consultor comercial ficam sem acompanhamento e podem perder oportunidades. Atribua um vendedor responsável em cada um.
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
          {semConsultor.slice(0, 8).map((c) => (
            <Badge
              key={c.id}
              variant="outline"
              className="border-red-500/40 text-red-400 hover:bg-red-500/10 cursor-pointer"
              onClick={() => openPanel(c)}
              data-testid={`sem-consultor-${c.id}`}
            >
              <Building2 className="w-3 h-3 mr-1" /> {c.condominio}
            </Badge>
          ))}
          {semConsultor.length > 8 && (
            <Badge variant="outline" className="border-red-500/40 text-red-400">
              +{semConsultor.length - 8} outros
            </Badge>
          )}
        </div>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="border-red-500/40 text-red-500 hover:bg-red-500/10 shrink-0"
        onClick={focarSemConsultor}
        data-testid="btn-focar-sem-consultor"
      >
        Ver na lista
      </Button>
    </div>
  );
}
